export default "__VITE_ASSET__CcyKOjAe__"